import { appendImagePreset, Preset } from 'Shared/image-sizes';

export { Preset } from './image-sizes';

export function setImageBackground(imageUrl?: string, preset?: Preset, gradient?: string) {
  const url = appendImagePreset(imageUrl, preset);

  if (gradient) {
    return `${gradient}, url(${url})`;
  }

  if (!preset || !url.includes('.jpg')) {
    return `url(${url})`;
  }

  const sources = [
    `url(${url})`,
    `-webkit-image-set(url(${url + "-wp"}), url(${url}))`,
    `image-set(url(${url + "-wp"}) type('image/webp'), url(${url}) type('image/jpg'))`,
  ];

  return sources;
}
